import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import axios from '../../../../services/Api'
import swal from 'sweetalert';
import { Button, Spinner } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap'
import { FiCopy } from 'react-icons/fi'
import moment from 'moment'
import {haversineDistance} from './../../../../utils/Helpers'
import './index.css'

export default function RouteDetails({ data }) {
  const [loading, setLoading] = useState(false)
  const [detail, setDetail] = useState(null)
  const history = useHistory();

  useEffect(() => {
    init()
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  let localizatorCod = null;
  const copyToClipboard = () => {
    localizatorCod.select();
    document.execCommand("copy");
    swal("Código copiado com sucesso",
      {
        title: "Sucesso!",
        buttons: {
          localizator: {
            text: "Localizador",
            value: "localizator",
          },
          cancel: "Continuar"
        },
        icon: "success",
      })
      .then((value) => {
        if (value === 'localizator') {
          history.push('/localizator');
        }
      });
  };

  async function getTravelDetails(id) {
    try {
      const response = await axios.get(`/api/travels/${id}`);
      setDetail(response.data)
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", "Não foi possível encontrar os detalhes dessa viagem", "error");
    }
  }

  const init = async () => {
    setLoading(true)
    await getTravelDetails(data._id)
    setLoading(false)
  }

  return (
    <div className="container-details">
      {loading ?
        <div className="center-loading-details">
          <Spinner animation="border" />
        </div>
        :
        <>
          {detail !== null &&
            <div>
              <Row>
                <Col>
                  <div><strong>Responsável:</strong> {detail.user.name}</div>
                  <strong>Localizador:</strong>
                  <div style={{ display: 'flex' }}>
                    <input readOnly value={detail.localizator} ref={(ref) => localizatorCod = ref} />
                    <Button className="edit-address-button" onClick={copyToClipboard}>
                      <FiCopy />
                    </Button>
                  </div>
                </Col>

                <Col>
                  <div><strong>Data de inicio:</strong> {detail.init_date != null ? moment.utc(detail.init_date).local().format('DD/MM HH:mm:ss') : detail.end_date}</div>
                  <div><strong>Data de fim:</strong> {detail.end_date != null ? moment.utc(detail.end_date).local().format('DD/MM HH:mm:ss') : '--'}</div>
                </Col>
              </Row>
              <br />
              <Row>
                <Col>
                  <h1>Origem</h1>
                  <div><strong>Endereço:</strong> {detail.origin.address}</div>
                  <div><strong>Cidade:</strong> {detail.origin.city}</div>
                  <div><strong>Estado:</strong> {detail.origin.state}</div>
                </Col>
                <Col>
                  <h1>Destino</h1>
                  <div><strong>Endereço:</strong>  {detail.destiny.address}</div>
                  <div><strong>Cidade:</strong>  {detail.destiny.city}</div>
                  <div><strong>Estado:</strong>  {detail.destiny.state}</div>
                </Col>
              </Row>
            </div>
          }

        </>
      }
    </div>
  )
}
